/**
 * CAPPONI — señales de la ficha de producto.
 *
 * Cuatro desplegables cerrados y ninguna forma de saber cual abre la gente.
 * Cual se abre ES el dato: dice que objecion pesa de verdad en cada drop, y
 * es la señal mas barata que hay para decidir que subir a la vista.
 *
 * No envía nada por su cuenta: empuja a dataLayer y a gtag si existen. Si no
 * hay analitica montada, no hace nada y no rompe nada.
 */
(function () {
  if (window.__capponiPdpSignals) return;
  window.__capponiPdpSignals = true;

  function send(name, payload) {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, payload);
      }
      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push(Object.assign({ event: name }, payload));
      }
    } catch (error) {
      /* la analitica nunca puede tumbar la ficha */
    }
  }

  function productContext() {
    var el = document.querySelector('sticky-add-to-cart[data-product-id]');
    var title = document.querySelector('.product-information h1');
    return {
      product_id: el ? el.getAttribute('data-product-id') : '',
      product_title: title ? title.textContent.trim() : '',
    };
  }

  // Los eventos toggle de <details> NO burbujean: hay que capturarlos.
  document.addEventListener(
    'toggle',
    function (event) {
      var details = event.target;
      if (!details || details.tagName !== 'DETAILS' || !details.open) return;
      if (!details.closest('.product-information')) return;

      var heading = details.querySelector('.accordion__title');
      send(
        'pdp_accordion_open',
        Object.assign(
          { accordion: heading ? heading.textContent.trim() : '' },
          productContext()
        )
      );
    },
    true
  );

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    if (target.closest('.capponi-size-block__toggle')) {
      send('pdp_size_guide_open', productContext());
    }

    if (target.closest('.capponi-trust__trigger')) {
      send('pdp_returns_open', productContext());
    }
  });
})();
